import React, { useState } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import * as moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  changeOverviewFilter,
  changeOverviewModal,
  setActiveRangeType,
} from "../../../../../redux/actions/overview";
import DropdownMenu from "../../../../universal/dropdown-menu";

import "./style.scss";
import { Title } from "../../../../library/title";

const Index = () => {
  const dispatch = useDispatch();

  const currentFilter = useSelector(
    (state) => state.overview.filters.sales && state.overview.filters.sales.name
  );

  const loading = useSelector((state) => state.overview.fetchSales.loading);

  const [timeframeDropdownOpen, setTimeframeDropdownOpen] = useState(false);

  const selectFilter = (filter) => {
    if (filter === "today") {
      const start = moment(Date.now())
        .set({ hour: 0, minute: 0, second: 0 })
        .unix();
      const end = moment(Date.now())
        .set({ hour: 23, minute: 59, second: 59 })
        .unix();
      dispatch(
        changeOverviewFilter({
          type: "sales",
          filter: { name: filter, range: { start: start, end: end } },
        })
      );
    } else if (filter === "yesterday") {
      const start = moment(Date.now())
        .subtract(1, "days")
        .set({ hour: 0, minute: 0, second: 0 })
        .unix();
      const end = moment(Date.now())
        .subtract(1, "days")
        .set({ hour: 23, minute: 59, second: 59 })
        .unix();
      dispatch(
        changeOverviewFilter({
          type: "sales",
          filter: { name: filter, range: { start: start, end: end } },
        })
      );
    } else if (filter === "week") {
      const start = moment(Date.now())
        .subtract(7, "days")
        .set({ hour: 0, minute: 0, second: 0 })
        .unix();
      const end = moment(Date.now())
        .set({ hour: 23, minute: 59, second: 59 })
        .unix();
      dispatch(
        changeOverviewFilter({
          type: "sales",
          filter: { name: filter, range: { start: start, end: end } },
        })
      );
    } else if (filter === "month") {
      const start = moment(Date.now())
        .subtract(28, "days")
        .set({ hour: 0, minute: 0, second: 0 })
        .unix();
      const end = moment(Date.now())
        .set({ hour: 23, minute: 59, second: 59 })
        .unix();
      dispatch(
        changeOverviewFilter({
          type: "sales",
          filter: { name: filter, range: { start: start, end: end } },
        })
      );
    } else if (filter === "quarter") {
      const start = moment(Date.now())
        .subtract(90, "days")
        .set({ hour: 0, minute: 0, second: 0 })
        .unix();
      const end = moment(Date.now())
        .set({ hour: 23, minute: 59, second: 59 })
        .unix();
      dispatch(
        changeOverviewFilter({
          type: "sales",
          filter: { name: filter, range: { start: start, end: end } },
        })
      );
    }
  };

  const selectCustomFilter = () => {
    dispatch(setActiveRangeType("sales"));
    dispatch(changeOverviewModal({ rangeModal: true }));
  };

  const selectOptions = [
    {
      title: "I dag",
      key: "today",
      active: currentFilter === "today",
      action: () => selectFilter("today"),
    },
    {
      title: "I går",
      key: "yesterday",
      active: currentFilter === "yesterday",
      action: () => selectFilter("yesterday"),
    },
    {
      title: "Èn uke",
      key: "week",
      active: currentFilter === "week",
      action: () => selectFilter("week"),
    },
    {
      title: "Èn måned",
      key: "month",
      active: currentFilter === "month",
      action: () => selectFilter("month"),
    },
    {
      title: "Et kvartal",
      key: "quarter",
      active: currentFilter === "quarter",
      action: () => selectFilter("quarter"),
    },
    {
      title: "separator",
      key: "separator",
    },
    {
      title: "Egendefinert",
      key: "custom",
      active: currentFilter === "custom",
      action: () => selectCustomFilter(),
    },
  ];

  const renderToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setTimeframeDropdownOpen(!timeframeDropdownOpen)}
        disabled={loading ? true : false}
        id="dropdown-filter"
      >
        <i class="fad fa-th-large"></i>
      </Dropdown.Toggle>
    );
  };

  return (
    <Row className="dashboard-new-sales-upper-row">
      <Col className="text-left title-col my-auto">
        <Title size="small">Salg</Title>
      </Col>
      <Col className="text-right button-col my-auto">
        <DropdownMenu
          content="regular"
          type="icon"
          toggle={renderToggle()}
          title="Velg tidsperiode"
          options={selectOptions}
          open={timeframeDropdownOpen}
          setOpen={setTimeframeDropdownOpen}
        />
      </Col>
    </Row>
  );
};

export default Index;
